var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinSolidLarge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6706 9.29146L14.7644 1.33166C14.3252 0.889447 13.6663 0.889447 13.2271 1.33166C12.7879 1.77387 12.7879 2.43719 13.2271 2.8794L13.4467 3.1005L7.07786 7.63317L3.56401 8.07538C2.46593 8.29648 1.47766 9.07035 1.14824 10.0653C0.818817 11.0603 1.03843 12.2764 1.80709 12.9397L5.65036 16.809L2.90517 19.5729C2.46593 20.0151 2.46593 20.6784 2.90517 21.1206C3.12478 21.3417 3.45421 21.4523 3.67382 21.4523C3.89344 21.4523 4.22286 21.3417 4.44248 21.1206L7.18767 18.3568L11.0309 22.2261C11.58 22.7789 12.2388 23 13.0075 23C13.3369 23 13.6663 23 13.8859 22.8894C14.984 22.5578 15.7527 21.5628 15.8625 20.4573L16.4115 16.9196L20.8038 10.6181L21.1333 10.9497C21.3529 11.1709 21.6823 11.2814 21.9019 11.2814C22.1215 11.2814 22.451 11.1709 22.6706 10.9497C23.1098 10.5075 23.1098 9.73367 22.6706 9.29146Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSolidLarge);
export default __webpack_public_path__ + "static/media/pin_solid_large.d8307b0bf571887c356accd6dd151e11.svg";
export { ForwardRef as ReactComponent };